import type { ResponseError } from "app/services/fetchService/defaults";

import { CrmErrorStatus } from "../constants";

export const isCrmConfigurationError = (error: ResponseError | null | undefined): boolean => {
    return error?.status === CrmErrorStatus.configurationError;
};
